export default "__VITE_ASSET__DkbBPAIr__"